<ion-content>
    <svg
        class="close"
        (click)="closeButtonClick()"
        width="40"
        height="40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            opacity=".1"
            width="40"
            height="40"
            rx="20"
            fill="url(#paint0_linear)"
        />
        <path
            d="M27 14.41L25.59 13 20 18.59 14.41 13 13 14.41 18.59 20 13 25.59 14.41 27 20 21.41 25.59 27 27 25.59 21.41 20 27 14.41z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear"
                x1="40"
                y1="0"
                x2="-6.4783"
                y2="29.9448"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#0069B4" />
                <stop offset="1" stop-color="#0B578E" />
            </linearGradient>
        </defs>
    </svg>
    <div class="desktop-view">
        <div class="image">
            <img *ngIf="image && image.length > 0" [src]="image" alt="" />
        </div>
        <div class="text">
            <h3 *ngIf="title && title.length > 0">{{ title }}</h3>
            <p *ngIf="text && text.length > 0">{{ text }}</p>
            <div
                *ngIf="buttonText && buttonText.length > 0"
                (click)="buttonClick()"
                class="button"
            >
                {{ buttonText }}
            </div>
        </div>
    </div>
</ion-content>
